<div class="map-results">
	<div>
	     <label class="control control--checkbox muted" style="display:inline-block;">
	         Update results when moving the map
	         <input type="checkbox" [(ngModel)]="trackExtent" (change)="toggleTrackExtent()" />
	         <div class="control__indicator"></div>
	     </label>            
	</div>
	<div id="record_{{i}}" *ngFor="let record of filmstripRecordsView; let i = index;"
	      (mouseenter)="onUpdateMapRecordActiveLocation(record, true)"
	      (mouseleave)="onUpdateMapRecordActiveLocation(record, false)"
	      class="well well-sm active-location"
	      title="{{record.tooltip}}">
	     <div class="controls-container">
	         <label *ngIf="!record.is_cluster" class="control control--checkbox" style="display:inline-block;">
	             <!-- 
	             	NOTE The global record selection indicator may show more selected records when checking 'all' due to the fact that
	             	the search result model contains more records than are shown by the geo-filtered filmstripRecordsView model.
	             -->
	             <input type="checkbox" [checked]="globalRecordService.globalRecordIdsHash[record.uuid]" (change)="toggleRecordId(record.uuid)" [attr.aria-label]="'Select ' + record.title" />
	             <div class="control__indicator"></div>
	         </label>                
             <div class="dropdown" style="display:inline;float:right" ngbDropdown>
				  <button ngbDropdownToggle
					  type="button"
					  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
					  aria-haspopup="true"
					  aria-expanded="true"
					  [attr.aria-label]="LOCALIZATION.more"
					  title="{{LOCALIZATION.more}}"
					  style="border: 0; background: transparent;">
						<i class="nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
				  </button>								  
                  <ul class="dropdown-menu custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
	                 <li role="menuitem">
	                     <a title="{{LOCALIZATION.viewDetails}}" (click)="onUpdateMapRecordPreview(record)" class="ng-binding">{{LOCALIZATION.viewDetails}}</a>
	                 </li>
	                 <li role="menuitem" *ngIf="record.geo">
	                     <a title="{{LOCALIZATION.zoomTo}}" (click)="onZoomToFilmstrip(record)" class="ng-binding">{{LOCALIZATION.zoomTo}}</a>
	                 </li>
	             </ul>
	         </div>
	     </div>
	     <div class="panel-body">
	         <div class="row">
	             <div class="col-sm-6">
	                <span class="result-title pointMe" style="display:block; padding-bottom:8px;" (click)="onUpdateMapRecordPreview(record)">{{record.title}}</span>
	                <div *ngIf="!record.is_cluster">
	                     <div class="result-map-fields">
	                     	<span class="result-label">{{LOCALIZATION.productSize}}:</span><span class="result-data">{{record.product_size}}</span>
	                     </div>
	                     <div class="result-map-fields">
	                     	<span class="result-label">{{LOCALIZATION.fileType}}:</span><span class="result-data">{{record.file_extension}}</span>
	                     </div>
	               </div>
	             </div>
	             <div class="col-sm-6 text-center pointMe">
	                 <img *ngIf="record._thumbs"
	                 	(click)="onUpdateMapRecordPreview(record)" 
	                 	class='img-thumbnail img-responsive center-block'
	                 	alt="Thumbnail for {{record.title}}"
	                 	loading="lazy" 
	                 	[src]="record._thumbs" 
	                    onerror="this.src='/app/aw-ui-angular/assets/img/product_default_thumbnail.webp'" />	                 
	                 <span *ngIf="record.is_cluster" class="badge result-map-count" (click)="onUpdateMapRecordPreview(record)">{{record.count}}</span>
	             </div> 
	         </div>                   
	     </div>
	</div>
</div>
